import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";
import addressListAdapter from "@/redux/slice/location/adapters/addressList";
import { CurrentLocationUpdatedStatus } from "@/redux/slice/location/enums/CurrentLocationUpdatedStatus";
import { LocationState } from "@/redux/slice/location/types/LocationState";

const initialAddressList = addressListAdapter.getInitialState();

const initialState: LocationState = {
  thunkStatus: {
    placeDetails: ThunkResolvedStatus.idle,
    addressListUpdated: ThunkResolvedStatus.idle,
    fetchingSearchPlaceSuggestions: ThunkResolvedStatus.idle,
  },
  currentLocationUpdated: CurrentLocationUpdatedStatus.idle,
  latitude: 0,
  longitude: 0,
  currentAddressId: "",
  city: "",
  pincode: "",
  country: "",
  state: "",
  addressList: initialAddressList,
  isAddressListUpdated: false,
  isAddressUpdated: true,
  pickAddressDialogOpen: false,
  addAddressDialogOpen: false,
  isPincodeServiceable: true,
  editAddressId: "",
  showPincodeModal: false,
  headerPincodeError: false,
  addressLoading: false,
  openChangeAddressPopup: false,
  isAlertOpen: false,
  alertMessage: "",
  isGreyBackground: false,
  userFromApp: false,
  userFromAppFooter: false,
  tatInput: "",
};

export default initialState;
